import { render, staticRenderFns } from "./BomImpiantoBle.vue?vue&type=template&id=6ed08064&"
import script from "./BomImpiantoBle.vue?vue&type=script&lang=js&"
export * from "./BomImpiantoBle.vue?vue&type=script&lang=js&"
import style0 from "./BomImpiantoBle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports